import { useEffect, useRef, useState } from "react";

export const useCarousel = (images = [], delay = 3000) => {
  // add clones
  const extendedImages = [
    images[images.length - 1],
    ...images,
    images[0],
  ];

  const [index, setIndex] = useState(1);
  const [enableTransition, setEnableTransition] = useState(true);
  const intervalRef = useRef(null);

  const total = images.length;

  const prev = () => {
    setIndex((prev) => prev - 1);
  };

  const next = () => {
    setIndex((prev) => prev + 1);
  };

  /* AUTO SLIDE */
  useEffect(() => {
    if (total <= 1) return;

    intervalRef.current = setInterval(() => {
      next();
    }, delay);

    return () => clearInterval(intervalRef.current);
  }, [total, delay]);

  /* HANDLE LOOP FIX */
  useEffect(() => {
    if (index === extendedImages.length - 1) {
      setTimeout(() => {
        setEnableTransition(false);
        setIndex(1);
      }, 700);
    }

    if (index === 0) {
      setTimeout(() => {
        setEnableTransition(false);
        setIndex(extendedImages.length - 2);
      }, 700);
    }

    setTimeout(() => {
      setEnableTransition(true);
    }, 50);
  }, [index, extendedImages.length]);

  return {
    index,
    prev,
    images: extendedImages,
    enableTransition,
  };
};
